import { render, staticRenderFns } from "./RacePlayerInfoSection.vue?vue&type=template&id=280f95e7&scoped=true"
import script from "./RacePlayerInfoSection.vue?vue&type=script&lang=ts"
export * from "./RacePlayerInfoSection.vue?vue&type=script&lang=ts"
import style0 from "./RacePlayerInfoSection.vue?vue&type=style&index=0&id=280f95e7&prod&lang=scss&scoped=true"
import style1 from "./RacePlayerInfoSection.vue?vue&type=style&index=1&id=280f95e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280f95e7",
  null
  
)

export default component.exports